var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 161.61 161.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2eb2e5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,149.68V70.47a1.62,1.62,0,0,0,.25-.39c1.91-7.45,7.16-11.54,14.81-11.55,6,0,12,0,18,0a3.46,3.46,0,0,0,2.76-1.12q18-18.1,36.13-36.16C77.67,15.55,83.33,9.74,89.17,4.13a13.94,13.94,0,0,1,20,.18q24.21,24.09,48.32,48.3a12.48,12.48,0,0,1,4,10.22,93,93,0,0,0,0,9.88c.15,24.92.08,49.85.08,74.78a14,14,0,0,1-4.4,10.27,16.64,16.64,0,0,1-7.59,3.91H12A17.85,17.85,0,0,1,4.66,158,16.33,16.33,0,0,1,0,149.68ZM81,68.15H15.34c-4.23,0-5.87,1.67-5.87,5.94v72.08c0,4.29,1.73,6,6,6H146.1c4.28,0,6-1.74,6-6V74.11c0-4.34-1.64-6-6-6ZM123.42,32.1c-.36-.39-.61-.67-.86-.92q-9.82-9.83-19.64-19.63c-2.63-2.63-5.14-2.62-7.78,0L49.51,57.18c-.35.36-.67.74-1.08,1.19a3.15,3.15,0,0,0,.6.15q23.58,0,47.17,0a2.23,2.23,0,0,0,1.36-.58C106.17,49.36,114.75,40.77,123.42,32.1Zm6.91,7.23-19.22,19.2a70.58,70.58,0,0,1,7.82.06,8.83,8.83,0,0,0,8.31-3.41c3-3.4,6.32-6.42,9.43-9.52Zm13.32,13.33-6,5.89h11.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.81,109c-3,0-6,.19-9,0a7.58,7.58,0,0,1-6.89-7.68c0-4.21,0-8.41,0-12.62a7.85,7.85,0,0,1,7.79-8c5.47-.08,10.94-.09,16.41,0a7.66,7.66,0,0,1,7.7,7.44c.15,4.51.15,9,0,13.56A7.62,7.62,0,0,1,44,109a10.09,10.09,0,0,1-1.09.12h-8Zm6.48-18.67H28.53v9.12H41.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.59,137.87H18.74v-9.45H40.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.75,128.46v9.37H52.81v-9.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.77,137.87H86.91v-9.4h21.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.93,128.47v9.35H121v-9.35Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredit);
export default __webpack_public_path__ + "static/media/credit.6d9cbc3929522e52e46ffedd55d00274.svg";
export { ForwardRef as ReactComponent };